// extracted by mini-css-extract-plugin
module.exports = {"associatedProductsContainer":"js","associatedProducts":"ks","associatedProductsHeading":"ls","centerRecos":"ms","subRecos":"ns"};